var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f41408",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21873b",
    d: "M.3 26.7h53.4V40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M.3 0h53.4v13.3H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f31509",
    d: "M18.7 11.8c1.9-4.1 7-6.1 11.6-4.4a8 8 0 0 1 4.8 4.4zm-2.2.5q-2.1-.1-4.3-.7-.5-.1-.3-.4 0-.2.5-.3c.4.2 2.4.6 4.1 1.4M27 5l-.4-4q0-.4.4-.4.3 0 .4.4c0 .5 0 2.3-.4 4m1 0q-.2-2 0-4 0-.4.4-.3.4 0 .3.4c0 .5-.2 2.3-.7 4m.9.2c0-1.8.2-3.7.3-4q.1-.5.5-.4.2.1.3.5c-.1.4-.5 2.2-1.1 3.9m.9.2c.1-1.8.6-3.7.7-4q.2-.4.5-.3t.3.5c-.2.4-.7 2.2-1.5 3.8m.9.2c.3-1.7 1-3.6 1-3.9q.3-.4.6-.2.3.1.2.5zm.8.3c.5-1.7 1.3-3.5 1.5-3.7q.3-.4.5-.2.3 0 .2.5c-.2.4-1 2-2.2 3.4m.9.4L34 2.8q.3-.3.5-.2a.4.4 0 0 1 .2.5c-.3.4-1.3 2-2.5 3.3m.7.5c.8-1.6 2-3.3 2.2-3.5q.3-.4.6-.1v.5c-.2.4-1.4 1.8-2.8 3m.8.5c1-1.5 2.2-3 2.5-3.3q.3-.3.6 0v.5c-.3.3-1.6 1.7-3.1 2.8m.7.6q1.3-1.7 2.8-3.1.4-.2.6 0v.5C37.4 5.7 36 7 34.4 8m.6.6c1-1 2-2 3.1-2.8q.5-.2.6 0 .1.1-.1.5Q37 7.6 35 8.6m.5.7q1.6-1.5 3.4-2.7.5-.1.6.1t-.2.5c-.4.3-2 1.3-3.8 2m.5.6 3.6-2.3q.5-.1.6.1t-.2.5zm.5.8 3.8-2q.5-.1.5.2.1.3-.2.5c-.4.1-2.2 1-4.1 1.3m.3.8q2-1 4-1.7.5-.1.6.2t-.3.4c-.5.2-2.3.8-4.3 1.1m.3.8 4.2-1.4q.4 0 .5.3t-.3.4c-.5.1-2.4.6-4.4.7M26 5.2l-.8-4q0-.4.3-.4t.5.4c0 .4.2 2.2 0 4m-1 0-1-3.7q0-.4.3-.4t.4.3q.5 2 .5 4m-.9.3q-.9-1.8-1.5-3.8 0-.4.2-.5.4 0 .5.3c.2.4.7 2.2.8 4m-.8.2-2-3.6q0-.5.3-.5t.5.2c.2.5.9 2.2 1.2 3.9m-.9.3q-1.2-1.5-2.2-3.5-.1-.4.2-.5t.5.2c.2.4 1 2 1.5 3.8m-.8.4L19 3.1q-.2-.3.1-.5l.6.2c.2.4 1.2 2 1.9 3.6m-.8.5-2.9-3q-.2-.5.1-.6.2-.2.6.1c.2.4 1.4 1.8 2.2 3.5m-.7.5Q18.4 6 16.9 4.5V4h.6c.3.4 1.6 1.8 2.6 3.4m-.7.5-3.5-2.5q-.2-.4 0-.5h.6c.3.3 1.7 1.6 2.9 3m-.7.6q-1.9-1-3.6-2.2-.4-.4 0-.6h.5q1.7 1.3 3.1 2.8m-.5.7-3.9-2q-.4-.3-.1-.5 0-.2.6 0c.4.2 2 1.2 3.4 2.5m-.6.8c-1.8-.6-3.7-1.5-4-1.7q-.4-.3-.2-.5t.6-.1c.4.2 2.1 1.1 3.6 2.2m-.4.7L13 9.4q-.4-.3-.2-.5.1-.3.5-.2c.5.2 2.3 1 3.9 2m-.4.8-4.2-1q-.5-.3-.3-.5.1-.3.5-.2c.5.1 2.4.7 4 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f31509",
    d: "M16.5 12.3q-2.1-.1-4.3-.7-.5-.1-.3-.4 0-.2.5-.3c.4.2 2.4.6 4.1 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.1 11.8H43v1H11z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/mw.36c3155a6e8dbdc6277e33abb56d8c11.svg";
export { ForwardRef as ReactComponent };